import { WebBridgeApi } from 'ijsbridge';

// app退后
export var useAppGoBack = function useAppGoBack() {
  WebBridgeApi.router({
    route: 'back'
  });
};